import { sortHealthCardModules } from '@estercare/ester-shared'
import { HealthPlanCardResponse } from '../api/ester-b2b-api/private/healthPlan/types'

export function sortHealthCards(cards: HealthPlanCardResponse[]): HealthPlanCardResponse[] {
  if (!cards || !Array.isArray(cards)) {
    return []
  }

  const modules = cards.map((card) => card.module)
  const sortedModules = sortHealthCardModules(modules)

  const moduleIndexMap = new Map(sortedModules.map((module, index) => [module, index]))

  return [...cards].sort((a, b) => {
    const positionA = moduleIndexMap.get(a.module)
    const positionB = moduleIndexMap.get(b.module)

    // If module is not found in the order, put it at the end
    const orderA = positionA !== undefined ? positionA : Infinity
    const orderB = positionB !== undefined ? positionB : Infinity

    return orderA - orderB
  })
}
